<template>
    <div>
        <div class="tw-min-h-[calc(100vh-190px)]">
            <Head :title="page.title" />
            <div class="container-fluid tw-mt-20 tw-mb-6">
                <div
                    class="container tw-bg-slate-100/80 tw-p-5 tw-rounded-lg"
                    v-html="page.description"
                ></div>
            </div>
        </div>
        <Copyright></Copyright>
    </div>
</template>

<script>
import { Head } from "@inertiajs/vue2";
import FooterSection from "@landing/Components/FooterSection.vue";
import Copyright from "@landing/Components/Copyright.vue";

export default {
    props: ["page"],
    components: {
        Head,
        FooterSection,
        Copyright,
    },
};
</script>
